import { useEffect, useState } from 'react'
import { checkPhoneNumber, setOnlyNumbers } from '../../utils/validationUtils'
import PersonalInformation from './PersonalInformation'
import OnepromathApplication from '../../resources/images/onepromath_application.png'
import OnepromathApplication2 from '../../resources/images/onepromath_application_2.png'
import OnepromathApplication3 from '../../resources/images/onepromath_application_3.png'
import OnepromathApplication4 from '../../resources/images/onepromath_application_4.png'

import OnepromathApplicationModal from './OnepromathApplicationModal'
import OnepromathApplicationResultModal from './OnepromathApplicationResultModal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ADVERTISEMENT_INFO, INFLUENCER_INFO } from '../../network/Endpoint'
import { useDispatch, useSelector } from 'react-redux'
import { getCookie } from '../../utils/cookieUtils'
import { countUpAsync, initAsync } from '../../store/slices/countdownSlice'

const Onepromath = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false)
  const [showApplicationResultModal, setShowApplicationResultModal] = useState(false)
  const [showPersonalInformationModal, setShowPersonalInformationModal] = useState(false)
  const [checked, setChecked] = useState(false)
  const [formData, setFormData] = useState({
    phoneNumber: '',
    applicationType: '',
    code: '',
  })
  const [message, setMessage] = useState()
  const [searchParams] = useSearchParams()
  const [info, setInfo] = useState({})
  const [isInfo, setIsInfo] = useState(false)
  const navigate = useNavigate()
  const countdownReducer = useSelector((state) => state.countdown)
  const dispatch = useDispatch()

  // usagePeriod 파라미터 가져오기.
  const usagePeriodParam = searchParams.get('usagePeriod') || 31

  useEffect(() => {
    // cookie가 undefined거나 빈 객체일 때 초기화
    const countdownCookie = getCookie('countdown')
    if (countdownCookie === undefined || (Object.keys(countdownCookie).length === 0 && countdownCookie.constructor === Object)) {
      dispatch(initAsync())
    }
    randomCountUp()
  }, [navigate])

  const openApplicationModal = (data) => {
    setShowApplicationModal(true)
  }

  const closeApplicationModal = () => {
    setShowApplicationModal(false)
  }

  const openApplicationResultModal = (e) => {
    setMessage(e)
    setShowApplicationResultModal(true)
  }

  const closeApplicationResultModal = () => {
    setShowApplicationResultModal(false)
  }

  const handleFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const openPersonalInformationModal = (data) => {
    setShowPersonalInformationModal(true)
  }

  const closePersonalInformationModal = () => {
    setShowPersonalInformationModal(false)
  }

  const openModal = () => {
    // isActive가 false인 경우 alert 띄우고 return
    if (info.isActive === false) {
      alert(info.inactiveReason)
      return
    }
    if (!checked) {
      alert('개인정보 수집 및 이용동의을 확인하고 동의하신다면 체크해 주세요.')
      return
    } else if (formData.phoneNumber === '') {
      alert('폰 번호를 입력해 주세요.')
      return
    } else if (!checkPhoneNumber(setOnlyNumbers(formData.phoneNumber))) {
      alert('폰 번호 형식을 확인해 주세요.')
      return
    }
    openApplicationModal()
  }

  const handleCheck = (e) => {
    if (e.target.checked) {
      setChecked(true)
    } else {
      setChecked(false)
    }
  }

  useEffect(() => {
    if (showApplicationModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showApplicationModal])

  useEffect(() => {
    if (showApplicationResultModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showApplicationResultModal])

  useEffect(() => {
    if (showPersonalInformationModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showPersonalInformationModal])

  const mystyle = {
    background: 'linear-gradient(#f3f4fc, #ebedf8)'
  }

  const getInfluencerInfo = async (body) => {
    await INFLUENCER_INFO(body)
      .then(async (res) => {
        if (res.data.statusResponse.code === 'M0001') { // 성공
          setIsInfo(true)
          setInfo(res.data.influencer)
          // isActive가 false인 경우 alert 띄우기
          if (res.data.influencer.isActive === false) {
            alert(res.data.influencer.inactiveReason)
          }
        } else {
          setIsInfo(false)
        }
      })
      .catch(async (error) => {
        console.log('INFLUENCER_INFO error: ', error)
      })
  }

  const getAdvertisementInfo = async (body) => {
    await ADVERTISEMENT_INFO(body)
      .then(async (res) => {
        if (res.data.statusResponse.code === 'M0001') { // 성공
          if (res.data.advertisement.title !== '') {
            setIsInfo(true)
            setInfo(res.data.advertisement)
            // isActive가 false인 경우 alert 띄우기
            if (res.data.advertisement.isActive === false) {
              alert(res.data.advertisement.inactiveReason)
            }
          } else {
            setIsInfo(false)
          }
        } else {
          setIsInfo(false)
        }
      })
      .catch(async (error) => {
        console.log('ADVERTISEMENT_INFO error: ', error)
      })
  }

  const randomCountUp = () => {
    if (countdownReducer.count < 95) { // count가 95 미만일 때에는 실행
      if (Math.random() < 0.5) { // 50% 미만 실행
        // 난수 생성
        let randomNumber = 0

        // 생성한 난수와 카운트를 더한 값이 95 이하일 때 실행
        while (true) {
          // Math.floor(Math.random() * (max - min + 1)) + min
          // 1~10 사이의 난수 생성
          randomNumber = Math.floor(Math.random() * (10 - 1 + 1)) + 1
          if (randomNumber + countdownReducer.count <= 95) {
            break
          }
        }
        const body = {
          randomNumber: randomNumber
        }
        dispatch(countUpAsync(body))
      }
    }
  }

  useEffect(() => {
    let applicationType = searchParams.get('application_type')
    let code = searchParams.get('code')
    if (applicationType && code) {
      setFormData({
        ...formData,
        applicationType: applicationType,
        code: code,
      })
      if (applicationType === 'INFLUENCER') { // 인플루언서
        const body = {
          code: code
        }
        getInfluencerInfo(body)
      } else if (applicationType === 'ADVERTISEMENT') { // 광고
        const body = {
          code: code
        }
        getAdvertisementInfo(body)
      }
    }
  }, [])

  return (
    <div className={'flex justify-center'}>
      <OnepromathApplicationModal showApplicationModal={showApplicationModal}
                                  closeApplicationModal={closeApplicationModal}
                                  parentFormData={formData}
                                  parentUsagePeriodParam={usagePeriodParam}
                                  openApplicationResultModal={openApplicationResultModal}
                                  randomCountUp={randomCountUp}/>
      <OnepromathApplicationResultModal showApplicationResultModal={showApplicationResultModal} closeApplicationResultModal={closeApplicationResultModal} message={message}/>
      <PersonalInformation showPersonalInformationModal={showPersonalInformationModal} closePersonalInformationModal={closePersonalInformationModal}/>
      <div className={'max-w-[500px]'}>
        {
          isInfo ? (
            <div className={'font-[kohi-baeum]'}>
              <div className={'flex justify-center items-center h-[80px] bg-[#32329d] text-[20px] text-[#ffffff]'}>
                {info.title}
              </div>
              <div className={'flex justify-center items-center h-[60px] bg-gradient-to-r from-[#4A55EF] to-[#5070FA]'}>
                <div className={'flex justify-center items-center w-[200px] h-[40px] bg-[#ffff80] text-[#32329d] rounded-full'}>
                  선착순: {countdownReducer.count}/100명
                </div>
              </div>
            </div>
          ) : null
        }
        <div>
          <img src={OnepromathApplication} alt={'OnepromathApplication'}/>
        </div>
        <div style={mystyle}>
          <div className={'flex justify-center pt-[20px]'}>
            <input type={'text'}
                   name={'phoneNumber'}
                   value={formData.phoneNumber || ''}
                   onChange={handleFormData}
                   className={'w-[300px] border-[2px] border-[#1a1f41] rounded-[10px] h-[60px] text-center font-[nanum-square-b] text-[24px]'}
                   placeholder={'010-0000-0000'}/>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] mt-[20px]'}>
            <div className={'text-[#1a1f41] flex items-center'}>
              <input type={'checkbox'} id={'checked'} checked={checked} onChange={(e) => handleCheck(e)} className={'flex items-center w-[18px] h-[18px]'}/>
              <label htmlFor={'checked'}>
                <div className={'ml-[6px]'}>{formData.code === 'AVT758' ? '개인정보 수집 및 마케팅 수신동의' : '개인정보 수집 및 이용동의(필수)'}</div>
              </label>
            </div>
            <button type={'button'} onClick={openPersonalInformationModal} className={'flex items-center text-[#666666] underline underline-offset-4 decoration-2 text-[12px] ml-[10px]'}>상세보기</button>
          </div>
          <div className={'flex justify-center mt-[20px]'}>
            <button type={'button'} onClick={openModal} className={'border border-[#32329d] bg-[#32329d] text-[#ffffff] font-[nanum-square-round-eb] text-[24px] w-[260px] h-[60px] rounded-[10px]'}>
              이용권 받기
            </button>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] text-[14px] mt-[10px] pb-[30px] text-[#6578b1]'}>
            * 일프로연산 1개월 체험권은 1년마다 신청이 가능합니다.
          </div>
        </div>
        <div>
          <img src="http://cdn.1promath.com/test/onepromath_review.gif" alt={'OnepromathReview1'}/>
          <img src={OnepromathApplication2} alt={'OnepromathApplication2'}/>
          <img src={OnepromathApplication3} alt={'OnepromathApplication3'}/>
          <a target="_blank" href={'https://1promath.com'}>
            <img src={OnepromathApplication4} alt={'OnepromathApplication4'}/>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Onepromath
